import Vue from 'vue';
import axios from 'axios';

const EventBus = new Vue({
  data() {
    return {
      inventory: [],
      options: {},
      requestInventoryCallbacks: [],
      requestInventoryStatus: 'WAITING_REQUEST',
      vehicleMatcher: {
        vehicle: null,
      }
    }
  },
  created() {
    window.addEventListener("load", this.onWindowLoad);
  },
  methods: {
    onWindowLoad() {
        var ts = Date.now();

        var url = window.location.href;
        if (!url.includes('local')) {
          axios.get('/wp-content/themes/base/resources/assets/styles/build/mix-manifest.json?v='+ts)
          .then(response => {
            document.getElementById('child-theme-styles-css').href = "/wp-content/themes/base/resources/assets/styles/build/"+response.data['/dealer.css'];
            document.getElementById('preload-child-css').href = "/wp-content/themes/base/resources/assets/styles/build/"+response.data['/dealer.css'];
          })
          .catch(() => {
          });
        }
    },
    tryGetFormSubmission() {
      wp.ajax.post("get_leadbox_ninja_forms_after_submission")
        .done((response) => {
          //log(response);
          alert("HOLAA");
          // callback(true);
        })
        .fail(() => {
          // console.log("Error get form submission");
          alert("ERRRRRR");
          //callback(false);
        })
    },
    tryGetInventoryFrom(target, callback, params) {
      wp.ajax.post("get_leadbox_inventory_from_" + target, { 'params': params })
        .done((response) => {
          this.inventory = JSON.parse(response);
          callback(true);
        })
        .fail(() => {
          //console.log("Fail Method");
          callback(false);
        })
    },
    httpRequestInventory(contentdir, callback, gutembergOptions) {  
      switch(this.requestInventoryStatus)
      {
            case 'WAITING_REQUEST':
              this.requestInventoryStatus = 'REQUESTING_INVENTORY';
              this.getUnfilteredInventory(this).then(
                (unfilteredInventory) => {
                  this.inventory = unfilteredInventory;
                        this.options = gutembergOptions;
                        this.gutembergOptionsFiltering();
                        this.requestInventoryStatus = 'REQUEST_SUCCESSFULLY_COMPLETED';
                        callback(this.inventory);
                        this.sendRemainingCallbacks();
                    },
                    () => {
                        this.requestInventoryStatus = 'REQUEST_FAILED';
                        callback([]);
                        this.sendRemainingCallbacks();
                    }
                )
                break;
            case 'REQUESTING_INVENTORY':
                this.requestInventoryCallbacks.push({ callback, gutembergOptions });
                break;
            case 'REQUEST_SUCCESSFULLY_COMPLETED' :
                callback(this.inventory);
                break;
            case 'REQUEST_INVENTORY_FAILED' :
                callback([]);
                break;
      }
    },
    getUnfilteredInventory(vueThis){
        return new Promise(function(resolve, reject) {
            var inventory = [];
            let needsUpdate = EventBus.needsUpdateJSONTimestamp(10,'Inventory');
            let lang = document.documentElement.lang;

            if(!needsUpdate && vueThis.isUnfilteredInventoryOnSessionStorage() && vueThis.isLangOnSessionStorage() && sessionStorage.getItem('lbxLang') == lang ){
                //console.log('inventory from session storage')
                inventory = vueThis.getUnfilteredInventoryFromSessionStorage();
                resolve(inventory);
            }else{
                //console.log('inventory from inventory')
                //console.log('/wp-content/uploads/data/inventory.json?v=' + EventBus.getJSONTimestamp(10));
                if(lang && lang == "fr-CA"){
                    var lg = "_fr";
                    sessionStorage.setItem('lbxLang', lang);
                }
                else if(lang && lang == "en-CA"){
                    sessionStorage.setItem('lbxLang', lang);
                    var lg = "";
                }

                    axios.get('/wp-content/uploads/data/inventory'+lg+'.json?v=' + EventBus.getJSONTimestamp(10,'Inventory') )
                //axios.get('/wp-content/uploads/data/inventory.json')
                .then(response => {
                  vueThis.storeUnfilteredInventoryOnSessionStorage(response.data.vehicles);
                  resolve(response.data.vehicles);
                })
                .catch(() => {
                  reject();
                });
            }
        })
    },
    isUnfilteredInventoryOnSessionStorage(){
        if(sessionStorage.getItem('unfilteredInventory'))
            return true;
        else
            return false;
    },
    isLangOnSessionStorage(){
        if(sessionStorage.getItem('lbxLang'))
            return true;
        else
            return false;
    },
    storeUnfilteredInventoryOnSessionStorage(inventory){
      var inventoryString = JSON.stringify(inventory);
      sessionStorage.setItem('unfilteredInventory', inventoryString);
    },
    getUnfilteredInventoryFromSessionStorage(){
        if(this.isUnfilteredInventoryOnSessionStorage()){
            return JSON.parse(sessionStorage.getItem('unfilteredInventory'));
        }else{
            return [];
        }
    },
    getLangFromSessionStorage(){
        if(this.isLangOnSessionStorage()){
            return sessionStorage.getItem('lbxLang');
        }else{
            return false;
        }
    },
    sendRemainingCallbacks(){
    this.requestInventoryCallbacks.forEach(cb => {
      this.inventory = this.getUnfilteredInventoryFromSessionStorage();
      this.options = cb.gutembergOptions;
      this.gutembergOptionsFiltering();
      cb.callback(this.inventory);
    });
    },
    checkValidCDN(url){
        let cdns =  ['cardealerstg.blob.core.windows.net', 'dealerphotocdn.azureedge.net', 'dealerphoto.blob.core.windows.net'];
        for (var i = 0; i < cdns.length; i++) {
          if (url.toLowerCase().indexOf(cdns[i]) !== -1) {
            return true;
            break;
          }
        }
        return false;
    },
    gutembergOptionsFiltering() {
      this.filterVehicles();
      this.sortInventory({ field: this.options.sort_by, order: this.options.sort_by_condition });
      this.limit();
    },
    limit() {
      if (this.options.limit > 0)
        this.inventory = this.inventory.slice(0, this.options.limit)
    },
    sortingPrioritize (PrioList = [], attribute ){
      return (vehicleOne,vehicleTwo) => {

        let attributeOne = vehicleOne[attribute], attributeTwo = vehicleTwo[attribute];
          
        let vehicleOnePos = PrioList.indexOf(attributeOne.toLowerCase()), vehicleTwoPos = PrioList.indexOf(attributeTwo.toLowerCase());
        return (vehicleOnePos>-1 && vehicleTwoPos>-1) ? vehicleOnePos - vehicleTwoPos 
                        : (vehicleOnePos>-1) ? -1 
                        : (vehicleTwoPos>-1) ? +1 
                        : vehicleOne-vehicleTwo
      } 
    },    
    sortInventoryAttribute(attribute,sortAttribute){
      const { inventory, options , arrayUnique ,sortingPrioritize } = this

      let unique = inventory.map(item => item[attribute]).filter((value, index, self) => self.indexOf(value) === index);
      let order = options[sortAttribute];   

     
      inventory.sort( sortingPrioritize( arrayUnique( order.concat( unique ) ),attribute ) );
    },
    sortInventoryDefault(payload){

      let { order, field }  =payload
      
      this.inventory.sort((vehicleA,vehicleB) => {
        
        let position = 0
        let nameA = vehicleA[field]; // ignore upper and lowercase
        let nameB = vehicleB[field]; // ignore upper and lowercase

        if (nameA < nameB) {
          (order == 'asc') ? position =-1 : position = 1            
        }
        if (nameA > nameB) {
          (order == 'asc') ? position =1 : position = -1            
        }

        return position;
      });
    },
    sortInventory(payload) {
      const {field} = payload
      let { sortInventoryAttribute, sortInventoryDefault }=this

      if(field === 'make (custom)')
        sortInventoryAttribute('make','sort_makes')      
      else if(field === 'model (custom)') {
        sortInventoryAttribute('model','sort_models')  
      }
      else {
        
        sortInventoryDefault(payload)
      }
    },
    arrayUnique(values){
      
      const valuesLowercase =values.map( value => { return value.toLowerCase() })
      let uniqueValues = valuesLowercase.filter( (value, index) => valuesLowercase.indexOf(value) === index )

      return uniqueValues

    },
    filterVehicles() {
      var $_vehicles = [];
      var $_stockWildcard = [];

      var $yearrange = this.parse_range(this.options['year'], true);
      var $pricerange = this.parse_range(this.options['price'], true);
      var $mileagerange = this.parse_range(this.options['mileage'], true);
      var $statusrange = this.parse_range(this.options['status']);
      var $makerange = this.parse_range(this.options['make']);
      var $modelrange = this.parse_range(this.options['model']);
      var $trimrange = this.parse_range(this.options['trim']);
      var $typerange = this.parse_range(this.options['type']);
      var $stockrange = this.parse_range(this.options['stock']);
      var $tagsrange = this.parse_range(this.options['tags']);
      var $flags = this.parse_range(this.options['flags']);

      $stockrange.forEach(element => {
        if (element.includes("*")) {
          $_stockWildcard.push(element.replace("*", ""));
        }
      });

      //console.log(this.inventory);
      Object.values(this.inventory).forEach(vehicle => {
        this.vehicleMatcher.vehicle = vehicle;
        var $is_match = this.vehicleMatcherMatch('year', $yearrange) &&
          this.vehicleMatcherMatch('make', $makerange) &&
          this.vehicleMatcherMatch('model', $modelrange) &&
          this.vehicleMatcherMatch('trim', $trimrange) &&
          this.vehicleMatcherMatch('price', $pricerange) &&
          this.vehicleMatcherMatch('mileage', $mileagerange) &&
          this.vehicleMatcherMatch('type', $typerange) &&
          this.vehicleMatcherMatch('condition', $statusrange, 'status') &&
          this.vehicleMatcherMatch('stocknumber', $stockrange, 'stock', $_stockWildcard) &&
          this.vehicleMatcherMatchAny('tags', $tagsrange) &&
          this.vehicleMatcherMatchFlags($flags);

        if ($is_match) {
          $_vehicles.push(vehicle);
        }
      })

      this.inventory = $_vehicles;
      //console.log(this.inventory);
    },
    parse_range($value, $evaluateHyphen = false) {
      var $range = [];

      if ($value != 'all') {
        if ($evaluateHyphen && $value.indexOf('-') !== -1) {
          $range = $value.split('-');
          $range = this.range($range[1] - $range[0], $range[0]);
        } else if ($value.indexOf(',') !== -1) {
          $range = $value.split(',');
        } else {
          $range = [$value];
        }
      }

      return $range;
    },
    range(size, startAt = 0) {
      var range = [];
      for (var i = 0; i <= size; i++) {
        range.push(startAt.toString() || startAt);
        startAt++;
      }
      return range;
    },
    vehicleMatcherMatch($property, $values, $propertyOptions = null, $stockWildcard = null) {
      $propertyOptions = $propertyOptions || $property;
      var $value = (this.vehicleMatcher.vehicle && this.vehicleMatcher.vehicle[$property]) ? this.vehicleMatcher.vehicle[$property] : "";
      var $findWildcard = false;
      if ($propertyOptions == "stock") {
        if ($stockWildcard) {
          if ($stockWildcard.length > 0) {
              $stockWildcard.forEach(element => {
              if ($value.includes(element)) {
                $findWildcard = true;
              }
            });
          }
        }
      }
      if ($findWildcard == true) {
        return true;
      } else {
        return this.options[$propertyOptions] == 'all' || $values.includes($value.toString() || parseFloat($value));
      }
    },
    vehicleMatcherMatchAny($property, $values, $delimiter = ',', $propertyOptions = null) {

      $propertyOptions = $propertyOptions || $property;

      if (this.options[$propertyOptions] == 'all') {
        return true;
      }
      var $arrayValue = (this.vehicleMatcher.vehicle[$property] || '').split($delimiter);

      for (var i = 0; i < $arrayValue.length; i++) {
        if ($values.includes($arrayValue[i]))
          return true;
      }
      return false;
    },
    vehicleMatcherMatchFlags($flags) {
      if ($flags.length === 0) {
        return true;
      }

      if ($flags.length === 1 && $flags[0] == "none") {
        return true;
      }

      var ret = true;

      for (var i = 0; i < $flags.length; i++) {
        if (!this.vehicleMatcher.vehicle[$flags[i]] && $flags[i] != 'excludeincoming' && $flags[i] != 'excludesalepending' && $flags[i] != 'excludedemo') {
         ret = false;
        }else if ($flags[i] == 'excludeincoming' && this.vehicleMatcher.vehicle['incoming']) {
          ret = false;
        }else if ($flags[i] == 'excludesalepending' && this.vehicleMatcher.vehicle['salepending']) {
         ret = false;
        }else if ($flags[i] == 'excludedemo' && this.vehicleMatcher.vehicle['demo']) {
         ret = false;
        }
      }

      return ret;
    },
    isEmpty(val) {
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    },
    string_contains_value(text, filter) {
      var array = filter.toLowerCase().split("_");
      var total_words = array.length;
      var vehicle = text.split(' ').map((item) => {
        return item.toLowerCase();
      })
      var total_coincidences = 0;
      array.forEach((item) => {
        var total_i = vehicle.filter((span) => {
          return span.includes(item);
        }).length;

        var total_p = vehicle.filter((span) => {
          return span.replace(/-/g, '').includes(item.replace(/-/, ''));
        }).length;

        if (total_i > 0 || total_p > 0)
          total_coincidences++;
      })

      if (total_words == total_coincidences) {
        return true;
      }
      else {
        return false;
      }
    },
    postFilterInventory(initialInventory, payload) {
      var stockNumber = payload.stockNumber;
      var mileageRange = payload.mileageRange;
      var priceRange = payload.priceRange;
      var filterValue = payload.filterValue;
      var selected = payload.selected;
      var dryweightRange = payload.dryweightRange;
      var grossweightRange = payload.grossweightRange;
      var sleepcapacityRange = payload.sleepcapacityRange;

      var filteredInventory = [];
      Object.values(initialInventory).forEach(item => {
        var super_string =
          (item['condition'] && this.isEmpty(item['condition']) ? ' ' : item['condition'] || '' + ' ')
          + (item['stocknumber'] && this.isEmpty(item['stocknumber']) ? ' ' : item['stocknumber'] || '' + ' ')
          + (item['year'] && this.isEmpty(item['year']) ? ' ' : item['year'] || '' + ' ')
          + (item['make'] && this.isEmpty(item['make']) ? ' ' : item['make'] || '' + ' ')
          + (item['lot'] && this.isEmpty(item['lot']) ? ' ' : item['lot'] || '' + ' ')
          + (item['model'] && this.isEmpty(item['model']) ? ' ' : item['model']+'s' || '' + ' ')
          + (item['type'] && this.isEmpty(item['type']) ? ' ' : item['type'] || '' + ' ')
          + (item['subtype'] && this.isEmpty(item['subtype']) ? ' ' : item['subtype'] || '' + ' ')
          + (item['trim'] && this.isEmpty(item['trim']) ? ' ' : item['trim'] || '' + ' ')
          + (item['bodystyle'] && this.isEmpty(item['bodystyle']) ? ' ' : item['bodystyle'] || '' + ' ')
          + (item['salepending'] && this.isEmpty(item['salepending']) ? ' ' : item['salepending'] || '' + ' ')
          + (item['price'] && this.isEmpty(item['price']) ? ' ' : item['price'] || '' + ' ')
          + (item['mileage'] && this.isEmpty(item['mileage']) ? ' ' : item['mileage'] || '' + ' ')
          + (item['exteriorcolor'] && this.isEmpty(item['exteriorcolor']) ? ' ' : item['exteriorcolor'] || '' + ' ')
          + (item['dryweight'] && this.isEmpty(item['dryweight']) ? ' ' : item['dryweight'] || '' + ' ')
          + (item['grossweight'] && this.isEmpty(item['grossweight']) ? ' ' : item['grossweight'] || '' + ' ')
          + (item['sleepcapacity'] && this.isEmpty(item['sleepcapacity']) ? ' ' : item['sleepcapacity'] || '' + '  ')
          + (item['length'] && this.isEmpty(item['length']) ? ' ' : item['length'] || '' + ' ')
          + (item['productline'] && this.isEmpty(item['productline']) ? ' ' : item['productline'] || '' + ' ')
          + (item['vin'] && this.isEmpty(item['vin']) ? ' ' : item['vin'] || '' + ' ');

        // condition
        if (
          item.condition &&
          selected.condition.length > 0 &&
          selected.condition.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
            .indexOf(item.condition.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase()) == -1
        )
          return;
        if (!item.condition && selected.condition.length > 0)
          return;

          
          // year
          if (
          item.year &&
          selected.year.length > 0 &&
          selected.year.indexOf(item.year) == -1
        )
          return;
        if (!item.year && selected.year.length > 0)
        return;
        
        // make
        if (
          item.make &&
          selected.make.length > 0 &&
          selected.make.map((item) => { return item.replace(/ /g, '-').toLowerCase() }).indexOf(item.make.replace(/ /g, '-').toLowerCase()) == -1
        )
        return;
        if (!item.make && selected.make.length > 0)
        return;
        
        // Lot
        if (
            item.lot &&
            selected.lot.length > 0 &&
            selected.lot.map((item) => { return item.replace(/ /g, '-').toLowerCase() }).indexOf(item.lot.replace(/ /g, '-').toLowerCase()) == -1
            )
            return;
            if (!item.lot && selected.lot.length > 0)
            return;
            
            // stock
        if (
          item.stocknumber &&
          selected.stock.length > 0 &&
          selected.stock.map((item) => { return item.replace(/ /g, '-').toLowerCase() }).indexOf(item.stocknumber.replace(/ /g, '-').toLowerCase()) == -1
        )
          return;
          if (!item.stocknumber && selected.stock.length > 0)
          return;
          
          // type
          if (
              item.type &&
              selected.type.length > 0 &&
              selected.type.map((item) => { return item.toUpperCase() }).indexOf(item.type.toUpperCase()) == -1
              )
              return;
              if (!item.type && selected.type.length > 0)
              return;
              
              // subtype
        if (
          item.subtype &&
          selected.subtype.length > 0 &&
          selected.subtype.map((item) => { return item.toLowerCase() }).indexOf(item.subtype.toLowerCase()) == -1
        )
        return;
        if (!item.subtype && selected.subtype.length > 0)
        return;
        
        // productline
        if (
          item.productline &&
          selected.productline.length > 0 &&
          selected.productline.map((item) => { return item.toLowerCase() }).indexOf(item.productline.toLowerCase()) == -1
          )
          return;
          if (!item.productline && selected.productline.length > 0)
          return;
          
          // length
          if (
              item["length"] &&
              selected.outsidelength.length > 0 && item.length &&
              selected.outsidelength.map((item) => { return item.toLowerCase() }).indexOf(item["length"].toLowerCase()) == -1
              )
              return;
              if (!item["length"] && selected.outsidelength.length > 0)
              return;
              
              // floorplantags
        if (
          item.floorplantags &&
          selected.floorplan.length > 0
        ) {
          var intersection = selected.floorplan.filter(o => item.floorplantags.includes(o));
          if (intersection.length < selected.floorplan.length)
          return;
        }
        if (!item.floorplantags && selected.floorplan.length > 0)
        return;
        
        // model
        if (
          item.model &&
          selected.model.length > 0 &&
          selected.model.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() }
          )
            .indexOf(item.model ? item.model.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1) {
                return;
            }
            if (!item.model && selected.model.length > 0)
            return;
            
            // trim
        if (
          item.trim &&
          selected.trim.length > 0 &&
          selected.trim.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
            .indexOf(item.trim ? item.trim.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
        )
          return;
          if (!item.trim && selected.trim.length > 0)
          return;
          
          // exteriorcolor
        if (
          item.exteriorcolor &&
          selected.colour.length > 0 &&
          selected.colour.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
            .indexOf(item.exteriorcolor ? item.exteriorcolor.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
        )
          return;
        if (!item.exteriorcolor && selected.colour.length > 0)
          return;
          
          // transmission
        if (
          item.transmission &&
          selected.transmission.length > 0 &&
          selected.transmission.indexOf(item.transmission.toUpperCase()) == -1
        )
          return;
          if (!item.transmission && selected.transmission.length > 0)
          return;
          
          // drivetrain
          if (
              item.drivetrain &&
              selected.drivetrain.length > 0 &&
              selected.drivetrain.indexOf(item.drivetrain.toUpperCase()) == -1
              )
              return;
              if (!item.drivetrain && selected.drivetrain.length > 0)
              return;
              
        // STATUS        
        if (
          item.incoming &&
          selected.status.length > 0 && 
          selected.status.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() }).indexOf("incoming") == -1
        )
          return;

        if (
          !item.incoming &&
          selected.status.length > 0 && 
          selected.status.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() }).indexOf("in-stock") == -1          
        )
          return;
          
          //Salepending
        if (
          item.salepending &&
          selected.salepending.length > 0 &&
          selected.salepending.includes("1") == false
        )
          return;

          if (
          !item.salepending &&
          selected.salepending.length > 0 &&
          selected.salepending.includes("0") == false
        )
        return;
        
        // engine displacement
        if (
            item.enginedisplacement &&
          selected.enginedisplacement.length > 0 &&
          selected.enginedisplacement.indexOf(item.enginedisplacement.toString()) == -1
        )
          return;
        if (!item.enginedisplacement && selected.enginedisplacement.length > 0)
          return;
          
          // bodystyle
          if (
          item.bodystyle &&
          selected.bodystyle.length > 0 &&
          selected.bodystyle.map((item) => { return item.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() })
            .indexOf(item.bodystyle ? item.bodystyle.replace(/ /g, '-').replace(/-+/g, '-').toLowerCase() : '') == -1
        )
          return;
          if (!item.bodystyle && selected.bodystyle.length > 0)
          return;
          
          //  stocknumber
        if (item.stocknumber && stockNumber.length > 0) {
          var stockNExploded = stockNumber.split(',').map(i => i.toLowerCase());

          if (!stockNExploded.includes(item.stocknumber.toLowerCase()))
          return;          
        }
    
        // price
        if (
          item.price &&
          !(item.price >= priceRange[0] && item.price <= priceRange[1])
        )
          return;
        if (
          !item.price &&
          (priceRange[0] > payload.minPrice || priceRange[1] < payload.maxPrice)
          )
          return;

        // mileage
        if (
          item.mileage &&
          !(item.mileage >= mileageRange[0] && item.mileage <= mileageRange[1])
        )
          return;
        if (
          !item.mileage &&
          (mileageRange[0] > payload.minMileage || mileageRange[1] < payload.maxMileage)
        )
          return;

        // dryweight
        if (
          item.dryweight &&
          !(item && item.dryweight != undefined && item.dryweight != null && parseInt(item.dryweight) >= parseInt(dryweightRange[0]) && parseInt(item.dryweight) <= parseInt(dryweightRange[1]))
        )
          return;
        if (
          !item.dryweight &&
          (dryweightRange[0] > payload.minDryweight || dryweightRange[1] < payload.maxDryweight)
        )
          return;

        // grossweight
        if (
          item.grossweight &&
          !(item && item.grossweight != undefined && item.grossweight != null && parseInt(item.grossweight) >= parseInt(grossweightRange[0]) && parseInt(item.grossweight) <= parseInt(grossweightRange[1]))
        )
          return;
        if (
          !item.grossweight &&
          (grossweightRange[0] > payload.minGrossweight || grossweightRange[1] < payload.maxGrossweight)
        )
          return;

        // sleepcapacity
        if (
          item.sleepcapacity &&
          !(item && item.sleepcapacity != undefined && item.sleepcapacity != null && parseInt(item.sleepcapacity) >= parseInt(sleepcapacityRange[0]) && parseInt(item.sleepcapacity) <= parseInt(sleepcapacityRange[1]))
        )
          return;
        if (
          !item.sleepcapacity &&
          (sleepcapacityRange[0] > payload.minSleepcapacity || sleepcapacityRange[1] < payload.maxSleepcapacity)
        )
          return;

        // superstring
        if (filterValue.length > 0 && !this.string_contains_value(super_string, filterValue.replace(/ /g, '_')))
          return;

        // searchablesarray
        if (
          item.searchablesarray &&
          selected.feature.length > 0
        ) {
          var featintersection = selected.feature.filter(o => item.searchablesarray
            .map(sa => sa.replace(/ /g, '-').toLowerCase())
            .includes(o.replace(/ /g, '-').toLowerCase()));
          if (featintersection.length < selected.feature.length)
            return;
        }
        if (!item.searchablesarray && selected.feature.length > 0)
          return;

        // searchables
        if (
          item.searchables &&
          selected.package.length > 0
        ) {
          var searchablesExploded = item.searchables.split(',').map(i => i.toLowerCase());
          var packintersection = selected.package.map(i => i.toLowerCase()).filter(o => searchablesExploded.includes(o));

          if (!packintersection.length)
            return;
          
        }
        if (!item.searchables && selected.package.length > 0)
          return;

        // engine
        if (
          item.engine &&
          selected.engine.length > 0 &&
          selected.engine.indexOf(item.engine.toUpperCase()) == -1
        ){
          return;
        }
        if (!item.engine && selected.engine.length > 0)
          return;
          
        // location
        if (
          item.location &&
          selected.location.length > 0 &&
          selected.location.indexOf(item.location.toUpperCase()) == -1
        )
          return;
        if (!item.location && selected.location.length > 0)
          return;
        
          //console.log(item.condition+" "+item.stocknumber)
        filteredInventory.push(item);

      })
      return filteredInventory;
    },
    getJSONTimestamp(minutes,name){
      let lastTimestamp = sessionStorage.getItem('lastUpdate' + name + 'JSON');
      //console.log("Session Storage: " + lastTimestamp);
      let currentDate = new Date();
      if(lastTimestamp){
        var lastUpdateDate   = new Date(lastTimestamp * 1000);
        let minutesDifference = ((currentDate - lastUpdateDate) /(60 * 1000));
        //console.log("Current Date: " + currentDate + " Last Date:"  + lastUpdateDate);
        if( minutesDifference <= minutes){
          //console.log("NO SE ACTUALIZA JSON TIMESTAMP" + lastUpdateDate);
          return lastUpdateDate;
        }
        else{
          sessionStorage.setItem('lastUpdate' + name + 'JSON', Math.floor(currentDate / 1000));
          //console.log("SE ACTUALIZA JSON TIMESTAMP (PASARON 5 MINUTOS)" + currentDate);
          return currentDate;
        }
      }
      else{
        sessionStorage.setItem('lastUpdate' + name + 'JSON', Math.floor(currentDate / 1000));
        //console.log("SE ACTUALIZA JSON TIMESTAMP (PRIMERA VEZ)" + currentDate);
        return currentDate;
      }
    },
    needsUpdateJSONTimestamp(minutes,name){
      let lastTimestamp = sessionStorage.getItem('lastUpdate' + name + 'JSON');
      //console.log("Session Storage: " + lastTimestamp);
      let currentDate = new Date();
      if(lastTimestamp){
        var lastUpdateDate   = new Date(lastTimestamp * 1000);
        let minutesDifference = ((currentDate - lastUpdateDate) /(60 * 1000));
        //console.log("Current Date: " + currentDate + " Last Date:"  + lastUpdateDate);
        if( minutesDifference <= minutes){
          //console.log("NO SE ACTUALIZA JSON TIMESTAMP" + lastUpdateDate);
          return false;
        }
        else{
          //console.log("SE ACTUALIZA JSON TIMESTAMP (PASARON 5 MINUTOS)" + currentDate);
          return true;
        }
      }
      else{
        return false;
      }
    },
  },
  mounted() {
    // this.tryGetFormSubmission();
    //alert("MOUNTTT");
  }
});
export default EventBus;